import * as yup from 'yup';
import { RemoteCoolerLocation, RemoteCoolerStatusType, RemoteCoolerType } from '../types';

export const createRemoteCoolerDialogSchema = yup.object().shape({
  status: yup
    .mixed<RemoteCoolerStatusType>()
    .oneOf(Object.values(RemoteCoolerStatusType))
    .required()
    .label('Remote cooler status type'),
  type: yup.mixed<RemoteCoolerType>().oneOf(Object.values(RemoteCoolerType)).required().label('Remote cooler type'),
  position: yup.number().required().label('Position'),
  location: yup
    .string()
    .nullable()
    .optional()
    .oneOf([...Object.values(RemoteCoolerLocation), null])
    .label('Location'),
  topPumpReturnRate: yup.string().nullable().default(null).label('Top pump return rate'),
  description: yup.string().nullable().default(null).label('Description'),
  cellarId: yup.string().required().label('Cellar'),
  shouldShift: yup.boolean().nullable().default(null).label('Should Shift')
});

export const updateRemoteCoolerDialogSchema = yup.object().shape({
  remoteCoolerId: yup.string().nullable().default(null).label('Remote cooler id'),
  status: yup
    .mixed<RemoteCoolerStatusType>()
    .oneOf(Object.values(RemoteCoolerStatusType))
    .required()
    .label('Remote cooler status type'),
  type: yup
    .mixed<RemoteCoolerType>()
    .oneOf(Object.values(RemoteCoolerType))
    .nullable()
    .required()
    .label('Remote cooler type'),
  location: yup
    .string()
    .nullable()
    .oneOf([...Object.values(RemoteCoolerLocation), null])
    .label('Location'),
  position: yup.number().required().label('Position'),
  topPumpReturnRate: yup.string().nullable().default(null).label('Top pump return rate'),
  description: yup.string().nullable().default(null).label('Description'),
  cellarId: yup.string().required().label('Cellar'),
  shouldShift: yup.boolean().nullable().default(null).label('Should Shift')
});
